import React from "react";
import { formatCurrency } from "../../UI/DesignStandards";
import {
  eventEntryFee,
  signupAdvertisedTotal,
} from "../../../utility/signupDashboard";

const CostSummary = ({ signup }) => {
  if (!signup) return null;

  const bowlers = signup.bowlers || signup.signupBowlers || [];
  const entryEach = eventEntryFee(signup.tournamentEvents);
  const totalPrimaryCost = entryEach * Math.max(bowlers.length, 0);
  const totalSidepotCost = bowlers.reduce(
    (total, bowler) => total + (bowler.totalSidepotCost || 0),
    0
  );
  const grandTotal = signupAdvertisedTotal(signup);

  return (
    <div className="card-board p-6">
      <h3 className="text-lg font-semibold text-brand-charcoal mb-4">
        Cost
      </h3>

      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-brand-muted">
            Event ({formatCurrency(entryEach)} per bowler)
          </span>
          <span className="font-medium text-brand-charcoal">
            {formatCurrency(totalPrimaryCost)}
          </span>
        </div>

        {totalSidepotCost > 0 ? (
          <div className="flex justify-between items-center">
            <span className="text-brand-muted">Sidepots</span>
            <span className="font-medium text-brand-charcoal">
              {formatCurrency(totalSidepotCost)}
            </span>
          </div>
        ) : null}

        <div className="pt-3 border-t border-brand-charcoal/10">
          <div className="flex justify-between items-center">
            <span className="text-lg font-semibold text-brand-charcoal">
              Total
            </span>
            <span className="text-lg font-semibold text-brand-charcoal">
              {formatCurrency(grandTotal)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CostSummary;
